<script>
  /* Executable code section of the program */
  //Tools importation
  import {
    isModalMeetingsOn,
    temporalData,
    indexPositionData,
    isModalUpdate,
    temporalBreakData,
    indexBreakData,
    currentEvent,
    invitedAttendeesArray,
    isAlertOn,
    alertMessagge,
    isReloadNecessary,
  } from "../../apis/storage";
  import {
    createNetworkingBreak,
    updateNetworkingBreak,
    idGenerator,
    createDocumentWithID,
    updateLocalData,
    updateMultipleDocuments,
    addAndDeleteMultipleDocuments,
    updateOneDocument
  } from "../../apis/APIS";

  //Components importation
  import SelectAttendees from "../SelectAttendees.svelte";

  // Auxiliary variables
  let data = {};
  $: typeBreak = data.typeBreak;
  let isCustomBreak = false;
  let attendeeCustomBreak = [];
  let updateAttendees = [];

  //Designation to empty values
  if ($isModalMeetingsOn) {
    data.eventBreak = $currentEvent;
    data.breakTittle = "";
    data.typeBreak = "";
    data.startTime = "";
    data.endTime = "";
    data.placeBreak = "";
    data.attendeesAuthorized = [];
    data.slotTime = [];
  } else if ($isModalUpdate) {
    data = $temporalBreakData;
    $invitedAttendeesArray = $temporalBreakData.attendeesAuthorized;
    updateAttendees = $invitedAttendeesArray;
  }

  //Function to undisplay modal
  const undisplayModal = () => {
    $isModalMeetingsOn = false;
    $isModalUpdate = false;
  };

  //Function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  // function to add networking break to database
  const addNetworkBreak = async () => {
    data.id = idGenerator();
    data.isVisibleBreak = true;
    //Destructuring variables from the prop object
    const { networkingBreaks } = $temporalData;
    const { programmedBreaks } = networkingBreaks[$indexPositionData];

    //Discrimination according to the type of break
    if (data.typeBreak === "" || data.typeBreak === "Regular") {
      //Function to Regular Breaks
      if (
        data.breakTittle === "" ||
        data.typeBreak === "" ||
        data.startTime === "" ||
        data.endTime === ""
      ) {
        // Alert for empty inputs
        $alertMessagge = "All fields must be completed.";
        displayAlert();
      } else {
        // Pushing break to the database
        data.totalTables = $temporalData.tablesNumber;
        data.scheduledMeetings = {
          meetingTable: 0,
          meetingTime: {
            startTime: data.startTime,
            endTime: data.endTime,
          },
        };

        /* $temporalData.scheduledMeets = [
          ...$temporalData.scheduledMeets,
          {
            breakId: data.id,
            meetingTime: {
              startTime: data.startTime,
              endTime: data.endTime,
            },
            meetingTable: 0,
          },
        ]; */
        programmedBreaks.push(data);
        createNetworkingBreak("events", $temporalData, $temporalData.id)
          .then(() => {
            createDocumentWithID("breaks", data.id, data);
            $alertMessagge = "Networking Break created successfully.";
            $isReloadNecessary = true;
            displayAlert();
            $invitedAttendeesArray = [];
            $isModalMeetingsOn = false;
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while creating the networking break.";
            displayAlert();
          });
      }
    }

    //Function to Custom Breaks
    else {
      if (
        data.breakTittle === "" ||
        data.typeBreak === "" ||
        data.startTime === "" ||
        data.endTime === "" ||
        data.placeBreak === "" ||
        $invitedAttendeesArray.length < 1
      ) {
        // Alert for empty inputs
        $alertMessagge =
          "All fields must be completed and you must authorize at least one attendee";
        displayAlert();
      } else {
        // Pushing break to the database
        programmedBreaks.push(data);
        //Attendee break asignation
        $invitedAttendeesArray.map((element) => {
          data.attendeesAuthorized.push(element);
          attendeeCustomBreak.push({
            id: element.id,
            fieldName: "customBreaks",
            values: [data.id],
          });
        });
        updateMultipleDocuments("users", attendeeCustomBreak)
          .then(() => {
            createDocumentWithID("breaks", data.id, data);
            createNetworkingBreak(
              "events",
              $temporalData,
              $temporalData.id
            ).then(() => {
              $alertMessagge = "Networkin Break updated successfully.";
              $isReloadNecessary = true;
              displayAlert();
              $invitedAttendeesArray = [];
              $isModalMeetingsOn = false;
            });
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while updating the networking break";
            displayAlert();
          });
      }
    }
  };
  // function to update networking break to database
  const updateNetworkBreak = async () => {
    //Discrimination according to the type of break
    //Function to Regular Breaks
    if (data.typeBreak === "" || data.typeBreak === "Regular") {
      if (
        data.breakTittle === "" ||
        data.startTime === "" ||
        data.endTime === ""
      ) {
        // Alert for empty inputs
        $alertMessagge = "All fields must be completed.";
        displayAlert();
      } else {
        // Pushing break to the database
        updateNetworkingBreak("events", $temporalData, $temporalData.id)
          .then(() => {
            $invitedAttendeesArray.map((element) => {
              data.attendeesAuthorized.push(element);
              attendeeCustomBreak.push({
                id: element.id,
                fieldName: "customBreaks",
                values: [data.id],
              });
            });

            $alertMessagge = "Networkin Break updated successfully.";
            $invitedAttendeesArray = [];
            $isModalMeetingsOn = false;
            $isReloadNecessary = true;
            displayAlert();
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while updating the networking breaks";
            displayAlert();
          });
      }
    }

    //Function to Custom Breaks
    else {
      if (
        data.breakTittle === "" ||
        data.startTime === "" ||
        data.endTime === "" ||
        data.placeBreak === "" ||
        $invitedAttendeesArray.length < 1
      ) {
        // Alert for empty inputs
        $alertMessagge =
          "All fields must be completed and you must authorize at least one attendee.";
        displayAlert();
      } else {
        let finalArray = []
        finalArray = data.attendeesAuthorized.concat($invitedAttendeesArray)
        let deleteAttendeesArray = [];
        data.attendeesAuthorized = $invitedAttendeesArray;
        //Attendee break asignation
        finalArray.forEach((element) =>{
          const found =  $invitedAttendeesArray.some((attendee) => element.id === attendee.id)
        
          if (found) {
          attendeeCustomBreak.push({
            id: element.id,
            fieldName: "customBreaks",
            values: [data.id],
          });
        } else {
          deleteAttendeesArray.push({
            id: element.id,
            fieldName: "customBreaks",
            values: [data.id],
          });
        }
        });

        /* updateAttendees.forEach((element) => {
          attendeeCustomBreak.push({
            id: element.id,
            fieldName: "customBreaks",
            values: [data.id],
          });
        }); */

        addAndDeleteMultipleDocuments("users",deleteAttendeesArray, attendeeCustomBreak)
          .then(() => {
            createNetworkingBreak(
              "events",
              $temporalData,
              $temporalData.id,
              false
            ).then(() => {
              updateOneDocument("breaks",$temporalData,$temporalData.id)
              $alertMessagge = "Networkin Break updated successfully.";
              $invitedAttendeesArray = [];
              $isModalMeetingsOn = false;
              $isReloadNecessary = true;
              displayAlert();
            });
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while updating the networking break";
            displayAlert();
          });
      }
    }
  };
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="modalSection">
  <div class="formContainer">
    <div class="closeBtnSection">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-lg icon"
        viewBox="0 0 16 16"
        on:click={undisplayModal}
        on:keypress={undisplayModal}
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
        />
      </svg>
    </div>
    <div class="inputsSection">
      <div class="headerForm">
        {#if $isModalMeetingsOn}
          <h2>Add Networking Break</h2>
        {:else}
          <h2>Update Networking Break</h2>
        {/if}
      </div>
      {#if isCustomBreak}
        <SelectAttendees eventUser={$temporalData.tittle} />
      {:else}
        <div class="bodyForm">
          <div class="containerInputs">
            {#if $isModalMeetingsOn}
              <div class="form-floating">
                <select
                  class="form-select"
                  name="country"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  bind:value={data.typeBreak}
                >
                  <option selected value="">Select break</option>
                  <option value="Regular">Regular</option>
                  <option value="Custom">Custom</option>
                </select>
                <label for="floatingSelect">Type of break</label>
              </div>
            {/if}
            <div class="form-floating">
              <input
                type="text"
                class="form-control inputForm"
                placeholder="Tittle Break"
                bind:value={data.breakTittle}
              />
              <label for="floatingPassword">Break Tittle</label>
            </div>
            <div class="form-floating">
              <input
                type="time"
                class="form-control inputForm"
                placeholder="Tittle Event"
                bind:value={data.startTime}
                step="3600"
              />
              <label for="floatingPassword">Start Time</label>
            </div>
            <div class="form-floating">
              <input
                type="time"
                class="form-control inputForm"
                placeholder="Tittle Event"
                step="3600"
                bind:value={data.endTime}
              />
              <label for="floatingPassword">End Time</label>
            </div>
            {#if typeBreak === "Custom"}
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control inputForm"
                  placeholder="Tittle Event"
                  bind:value={data.placeBreak}
                />
                <label for="floatingPassword">Place</label>
              </div>
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control inputForm"
                  placeholder="Tittle Event"
                  bind:value={data.limitAttendees}
                />
                <label for="floatingPassword">Limit Attendees</label>
              </div>
            {:else}
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control inputForm"
                  placeholder="Tittle Event"
                  bind:value={data.slotTime}
                />
                <label for="floatingPassword">Time Slots (Minutes)</label>
              </div>
            {/if}
          </div>
        </div>
      {/if}
      <div class="actionBtnSection">
        {#if data.typeBreak === "Custom"}
          {#if isCustomBreak}
            {#if $isModalMeetingsOn}
              <button
                class="actionBtn addEventBtn"
                on:click={() => (isCustomBreak = false)}>Back</button
              >
              <button class="actionBtn addEventBtn" on:click={addNetworkBreak}
                >Add Break</button
              >
            {:else}
              <button
                class="actionBtn addEventBtn"
                on:click={() => (isCustomBreak = false)}>Back</button
              >
              <button
                class="actionBtn addEventBtn"
                on:click={updateNetworkBreak}>Update Break</button
              >
            {/if}
          {:else}
            <button
              class="actionBtn addEventBtn"
              on:click={() => (isCustomBreak = true)}
              >Attendee authorization</button
            >
          {/if}
        {:else}
          <button class="actionBtn" on:click={undisplayModal}>Close</button>
          {#if $isModalMeetingsOn}
            <button class="actionBtn addEventBtn" on:click={addNetworkBreak}
              >Add Break</button
            >
          {:else}
            <button class="actionBtn addEventBtn" on:click={updateNetworkBreak}
              >Update Break</button
            >
          {/if}
        {/if}
      </div>
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal sytles */
  .modalSection {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.514);
    width: 100%;
    height: 100dvh;
    top: 0;
    display: flex;
    justify-content: center;
    padding: 30px;
    z-index: 888;
  }
  /* Content container styles */
  .formContainer {
    background-color: white;
    padding: 20px;
    width: 60%;
    height: auto;
    max-height: 90dvh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .inputsSection,
  .closeBtnSection,
  .actionBtnSection {
    width: 100%;
    padding: 20px;
  }
  /* Header Content styles */
  .closeBtnSection {
    display: flex;
    justify-content: flex-end;
  }
  .headerForm {
    width: 100%;
    border-bottom: 1px solid black;
    margin-bottom: 20px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  } /* Body Content styles */
  .containerInputs {
    display: flex;
    flex-wrap: wrap;
  }
  .form-floating {
    margin: 10px;
    width: 220px;
  }
  .inputForm {
    width: 100%;
  }
  /* Footer Content styles */
  .actionBtnSection {
    display: flex;
    justify-content: center;
    border-top: 1px solid black;
    margin-top: 15px;
  }
  .actionBtn {
    width: 250px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .formContainer {
      background-color: white;
      padding: 20px;
      width: 80%;
      height: 550px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  /* /////////Cellphones ///////// */

  @media (max-width: 700px) {
    .modalSection {
      position: fixed;
      height: 100dvh;
      padding: 10px;
    }
    .formContainer {
      background-color: white;
      padding: 10px;
      width: 100%;
      height: auto;
      max-height: 90dvh;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .inputsSection,
    .closeBtnSection,
    .actionBtnSection {
      width: 100%;
      padding: 10px;
    }
    .containerInputs {
      display: flex;
      flex-direction: column;
    }
    .form-floating {
      margin: 10px 0;
      width: 100%;
    }
    .inputForm {
      width: 100%;
    }
    .actionBtnSection {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-top: 1px solid black;
      margin-top: 15px;
    }
    .actionBtn {
      width: 250px;
      border-radius: 12px;
      padding: 8px 16px;
      background-color: white;
      color: #111;
      border: 1px solid #444;
      transition: all 0.3s ease-in-out;
      margin: 10px 0;
    }
  }

  /* End of the section */
</style>
